import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, InputNumber, Select, DatePicker, Row, Col, Button, Radio } from 'antd';
import { UploadMultiFile } from '@components';
import dayjs from 'dayjs';
import { Get } from '@app/utils/httpProvider';
import { DON_VI_API } from '@app/utils/apiUrl';
import {
    GIOI_TINH, HOC_VI, CHUC_DANH_KH, BAC_DAO_TAO,
    VAI_TRO_BAI_BAO, LOAI_TAP_CHI, VAI_TRO_DE_TAI, CAP_DE_TAI, XEP_LOAI_KET_QUA,
    VAI_TRO_SANG_CHE, CAP_GIAI_THUONG, LOAI_SACH, VAI_TRO_SACH,
    BAC_HOC_VIEN, TRACH_NHIEM_HD, TRANG_THAI_HD
} from '@app/utils/define';

const { Option } = Select;
const { TextArea } = Input;

const validateMinhChung = (_, value) => {
    if (!value || value === '[]' || (Array.isArray(value) && value.length === 0)) {
        return Promise.reject(new Error('Vui lòng tải lên tài liệu minh chứng'));
    }
    return Promise.resolve();
};

// 1. MODAL THÔNG TIN CÁ NHÂN (PERSONAL INFO)
export const PersonalModal = ({ visible, onCancel, onSubmit, initialValues }) => {
    const [form] = Form.useForm();
    const [donVis, setDonVis] = useState([]);

    useEffect(() => {
        if (visible) {
            form.setFieldsValue({
                ...initialValues,
                ngaySinh: initialValues.ngaySinh ? dayjs(initialValues.ngaySinh) : null
            });
            // Tải danh sách đơn vị công tác
            Get(DON_VI_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 })
                .then(res => {
                    if (res && res.data) {
                        const checkActive = (item) => {
                            if (!item) return false;
                            const val = item.isActive;
                            if (val === undefined || val === null) return false;
                            const str = String(val).trim().toLowerCase();
                            return str !== 'false' && str !== '0' && str !== 'null' && str !== 'undefined';
                        };
                        setDonVis(res.data.filter(checkActive));
                    }
                }).catch(e => console.error(e));
        }
    }, [visible, initialValues, form]);

    const handleOk = () => {
        form.validateFields().then(values => {
            onSubmit({
                ...values,
                ngaySinh: values.ngaySinh ? dayjs(values.ngaySinh).format('YYYY-MM-DD') : null
            });
        }).catch(() => {});
    };

    return (
        <Modal
            title="Chỉnh sửa thông tin cá nhân"
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            width={850}
            okText="Lưu lại"
            cancelText="Hủy bỏ"
        >
            <Form form={form} layout="vertical" initialValues={initialValues}>
                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="hoTen" label="Họ và tên " rules={[{ required: true, message: 'Vui lòng nhập họ tên' }]}>
                            <Input placeholder="Họ và tên giảng viên" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Form.Item name="ngaySinh" label="Ngày sinh " rules={[{ required: true, message: 'Vui lòng chọn ngày sinh' }]}>
                            <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Form.Item name="gioiTinh" label="Giới tính " rules={[{ required: true, message: 'Chọn giới tính' }]}>
                            <Select placeholder="Giới tính">
                                {GIOI_TINH.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="dienThoaiDiDong" label="Điện thoại di động " rules={[{ required: true, message: 'Vui lòng nhập số điện thoại' }]}>
                            <Input placeholder="Số điện thoại di động" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="emailCongViec" label="Email " rules={[{ required: true, type: 'email', message: 'Vui lòng nhập đúng định dạng email' }]}>
                            <Input placeholder="Email công việc" />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="soCMND_CCCD" label="Số CMND/CCCD " rules={[{ required: true, message: 'Vui lòng nhập số CMND/CCCD' }]}>
                            <Input placeholder="Số CMND hoặc căn cước công dân" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="maSoThue" label="Mã số thuế">
                            <Input placeholder="Mã số thuế cá nhân" />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="soTaiKhoan" label="Số tài khoản ngân hàng">
                            <Input placeholder="Số tài khoản ngân hàng" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="nganHang" label="Tên ngân hàng mở thẻ">
                            <Input placeholder="Tên ngân hàng" />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} md={8}>
                        <Form.Item name="chucVu" label="Chức vụ " rules={[{ required: true, message: 'Vui lòng nhập chức vụ' }]}>
                            <Input placeholder="Chức vụ hiện tại" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                        <Form.Item name="donViId" label="Đơn vị khoa/phòng " rules={[{ required: true, message: 'Vui lòng chọn đơn vị' }]}>
                            <Select placeholder="Chọn đơn vị công tác">
                                {donVis.map(u => (
                                    <Option key={u.id} value={u.id}>{u.tenDonVi}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                        <Form.Item name="tenDonViTuNhap" label="Đơn vị tự nhập (nếu không có trong danh sách)">
                            <Input placeholder="Nhập đơn vị công tác khác" />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="hocViCaoNhat" label="Học vị cao nhất " rules={[{ required: true, message: 'Chọn học vị' }]}>
                            <Select placeholder="Chọn học vị cao nhất">
                                {HOC_VI.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="chucDanhKHCaoNhat" label="Chức danh khoa học cao nhất " rules={[{ required: true, message: 'Chọn chức danh khoa học' }]}>
                            <Select placeholder="Chọn chức danh khoa học">
                                {CHUC_DANH_KH.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item name="hinhAnh" label="Đường dẫn ảnh đại diện (Avatar)">
                            <Input placeholder="URL ảnh đại diện hoặc upload thông qua file manager" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

// 2. MODAL QUÁ TRÌNH ĐÀO TẠO (EDUCATION DETAILS)
export const DaoTaoModal = ({ visible, onCancel, onSubmit, initialValues }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            form.resetFields();
            form.setFieldsValue(initialValues);
        }
    }, [visible, initialValues, form]);

    const handleOk = () => {
        form.validateFields().then(values => {
            onSubmit(values);
        }).catch(() => {});
    };

    return (
        <Modal
            title={initialValues.id ? "Sửa quá trình đào tạo" : "Thêm quá trình đào tạo"}
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            okText="Lưu lại"
            cancelText="Hủy bỏ"
            width={600}
        >
            <Form form={form} layout="vertical">
                <Form.Item name="bacDaoTao" label="Bậc đào tạo " rules={[{ required: true, message: 'Vui lòng chọn bậc đào tạo' }]}>
                    <Select placeholder="Chọn bậc đào tạo">
                        {BAC_DAO_TAO.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item name="truongDaoTao" label="Trường / Cơ sở đào tạo " rules={[{ required: true, message: 'Nhập trường đào tạo' }]}>
                    <Input placeholder="Tên trường học hoặc cơ sở đào tạo" />
                </Form.Item>

                <Form.Item name="chuyenNganh" label="Chuyên ngành " rules={[{ required: true, message: 'Nhập chuyên ngành' }]}>
                    <Input placeholder="Chuyên ngành đào tạo" />
                </Form.Item>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="namTotNghiep" label="Năm tốt nghiệp " rules={[{ required: true, message: 'Nhập năm tốt nghiệp' }]}>
                            <InputNumber style={{ width: '100%' }} placeholder="Năm tốt nghiệp" />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item label="Minh chứng bằng cấp" name="fileMinhChung" rules={[{ required: true, validator: validateMinhChung }]}>
                    <UploadMultiFile />
                </Form.Item>
            </Form>
        </Modal>
    );
};

// 3. MODAL NGOẠI NGỮ (LANGUAGES)
export const NgoaiNguModal = ({ visible, onCancel, onSubmit, initialValues }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            form.resetFields();
            form.setFieldsValue(initialValues);
        }
    }, [visible, initialValues, form]);

    const handleOk = () => {
        form.validateFields().then(values => {
            onSubmit(values);
        }).catch(() => {});
    };

    return (
        <Modal
            title={initialValues.id ? "Sửa chứng chỉ ngoại ngữ" : "Thêm chứng chỉ ngoại ngữ"}
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            okText="Lưu lại"
            cancelText="Hủy bỏ"
        >
            <Form form={form} layout="vertical">
                <Form.Item name="tenNgoaiNgu" label="Tên bằng / Chứng chỉ " rules={[{ required: true, message: 'Nhập tên bằng/chứng chỉ (ví dụ: Tiếng Anh IELTS)' }]}>
                    <Input placeholder="Tên bằng / Chứng chỉ ngoại ngữ" />
                </Form.Item>

                <Form.Item name="mucDo" label="Mức độ " rules={[{ required: true, message: 'Nhập mức độ (ví dụ: IELTS 7.0, B2...)' }]}>
                    <Input placeholder="Mức độ đạt được" />
                </Form.Item>

                <Form.Item name="noiCap" label="Nơi cấp " rules={[{ required: true, message: 'Nhập nơi cấp chứng chỉ' }]}>
                    <Input placeholder="Nơi cấp chứng chỉ" />
                </Form.Item>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="thoiGianCap" label="Thời gian được cấp " rules={[{ required: true, message: 'Nhập thời gian được cấp' }]}>
                            <Input placeholder="dd/mm/yyyy hoặc mm/yyyy" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="thuTu" label="Thứ tự hiển thị">
                            <InputNumber min={1} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item label="Minh chứng" name="fileMinhChung" rules={[{ required: true, validator: validateMinhChung }]}>
                    <UploadMultiFile />
                </Form.Item>
            </Form>
        </Modal>
    );
};

// 4. MODAL BÀI BÁO KHOA HỌC
export const BaiBaoModal = ({ visible, onCancel, onSubmit, initialValues }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            form.resetFields();
            form.setFieldsValue(initialValues);
        }
    }, [visible, initialValues, form]);

    const handleOk = () => {
        form.validateFields().then(values => {
            onSubmit(values);
        }).catch(() => {});
    };

    return (
        <Modal
            title={initialValues.id ? "Sửa bài báo khoa học" : "Khai báo bài báo khoa học mới"}
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            width={750}
            okText="Lưu lại (Chờ duyệt)"
            cancelText="Hủy bỏ"
        >
            <Form form={form} layout="vertical">
                <Form.Item name="tenBaiBao" label="Tên bài báo " rules={[{ required: true, message: 'Vui lòng nhập tên bài báo' }]}>
                    <TextArea rows={2} placeholder="Tên đầy đủ của công trình / bài báo" />
                </Form.Item>

                <Row gutter={16}>
                    <Col xs={24} sm={8} md={8}>
                        <Form.Item name="soTacGia" label="Số lượng tác giả " rules={[{ required: true, message: 'Nhập số tác giả' }]}>
                            <InputNumber min={1} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={16} md={16}>
                        <Form.Item name="vaiTroTacGia" label="Vai trò của cán bộ " rules={[{ required: true, message: 'Chọn vai trò' }]}>
                            <Select placeholder="Chọn vai trò của bạn">
                                {VAI_TRO_BAI_BAO.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item name="tenTapChi" label="Tên tạp chí công bố " rules={[{ required: true, message: 'Vui lòng nhập tên tạp chí' }]}>
                    <Input placeholder="Tên tạp chí khoa học" />
                </Form.Item>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="loaiTapChi" label="Phân loại tạp chí " rules={[{ required: true, message: 'Chọn phân loại' }]}>
                            <Select placeholder="Phân loại tạp chí">
                                {LOAI_TAP_CHI.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="issnIsbn" label="Mã số ISSN / ISBN " rules={[{ required: true, message: 'Vui lòng nhập mã số ISSN/ISBN' }]}>
                            <Input placeholder="Mã ISSN/ISBN" />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} sm={8} md={8}>
                        <Form.Item name="nam" label="Năm công bố " rules={[{ required: true, message: 'Nhập năm công bố' }]}>
                            <InputNumber min={1950} max={2100} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={8} md={8}>
                        <Form.Item name="tapSoTrang" label="Tập, Số, Trang " rules={[{ required: true, message: 'Vui lòng nhập tập, số, trang' }]}>
                            <Input placeholder="Ví dụ: Vol 12, No.3, pp 45-56" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={8} md={8}>
                        <Form.Item name="soLanTrichDan" label="Số lần trích dẫn " rules={[{ required: true, message: 'Vui lòng nhập số lần trích dẫn' }]}>
                            <InputNumber min={0} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item name="linkBaiBao" label="Link bài báo (URL)">
                    <Input placeholder="Đường dẫn trực tuyến của bài báo (DOI / PubMed...)" />
                </Form.Item>

                <Form.Item label="Tài liệu minh chứng đính kèm (Ảnh bài báo / File PDF)" name="fileMinhChung" rules={[{ required: true, validator: validateMinhChung }]}>
                    <UploadMultiFile />
                </Form.Item>
            </Form>
        </Modal>
    );
};

// 5. MODAL NHIỆM VỤ KHCN (ĐỀ TÀI CÁN BỘ)
export const DeTaiModal = ({ visible, onCancel, onSubmit, initialValues }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            form.resetFields();
            form.setFieldsValue({
                ...initialValues,
                thoiGianTuNgay: initialValues.thoiGianTuNgay ? dayjs(initialValues.thoiGianTuNgay) : null,
                thoiGianDenNgay: initialValues.thoiGianDenNgay ? dayjs(initialValues.thoiGianDenNgay) : null,
                thoiGianNghiemThu: initialValues.thoiGianNghiemThu ? dayjs(initialValues.thoiGianNghiemThu) : null,
            });
        }
    }, [visible, initialValues, form]);

    const handleOk = () => {
        form.validateFields().then(values => {
            onSubmit({
                ...values,
                thoiGianTuNgay: values.thoiGianTuNgay ? dayjs(values.thoiGianTuNgay).format('YYYY-MM-DD') : null,
                thoiGianDenNgay: values.thoiGianDenNgay ? dayjs(values.thoiGianDenNgay).format('YYYY-MM-DD') : null,
                thoiGianNghiemThu: values.thoiGianNghiemThu ? dayjs(values.thoiGianNghiemThu).format('YYYY-MM-DD') : null,
            });
        }).catch(() => {});
    };

    return (
        <Modal
            title={initialValues.id ? "Sửa nhiệm vụ KHCN" : "Khai báo nhiệm vụ KHCN mới"}
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            width={750}
            okText="Lưu lại (Chờ duyệt)"
            cancelText="Hủy bỏ"
        >
            <Form form={form} layout="vertical">
                <Form.Item name="tenNhiemVu" label="Tên nhiệm vụ KHCN / Đề tài " rules={[{ required: true, message: 'Vui lòng nhập tên đề tài' }]}>
                    <TextArea rows={2} placeholder="Tên đề tài nghiên cứu khoa học, nhiệm vụ công nghệ" />
                </Form.Item>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="vaiTro" label="Vai trò của cán bộ " rules={[{ required: true, message: 'Vui lòng chọn vai trò' }]}>
                            <Select placeholder="Chọn vai trò">
                                {VAI_TRO_DE_TAI.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="maSoCapQuanLy" label="Mã số đề tài / Cấp quản lý " rules={[{ required: true, message: 'Nhập cấp quản lý' }]}>
                            <Select placeholder="Chọn cấp quản lý đề tài">
                                {CAP_DE_TAI.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} sm={8} md={8}>
                        <Form.Item name="thoiGianTuNgay" label="Thời gian bắt đầu " rules={[{ required: true, message: 'Chọn thời gian bắt đầu' }]}>
                            <DatePicker picker="month" format="MM/YYYY" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={8} md={8}>
                        <Form.Item name="thoiGianDenNgay" label="Thời gian kết thúc " rules={[{ required: true, message: 'Chọn thời gian kết thúc' }]}>
                            <DatePicker picker="month" format="MM/YYYY" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={8} md={8}>
                        <Form.Item name="thoiGianNghiemThu" label="Thời gian nghiệm thu thực tế">
                            <DatePicker picker="month" format="MM/YYYY" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="xepLoaiKetQua" label="Xếp loại kết quả nghiệm thu">
                            <Select placeholder="Chọn kết quả xếp loại">
                                {XEP_LOAI_KET_QUA.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="soThangThamGia" label="Số tháng tham gia thực tế " rules={[{ required: true, message: 'Nhập số tháng tham gia' }]}>
                            <InputNumber min={1} style={{ width: '100%' }} placeholder="Số tháng đóng góp công sức" />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item label="Minh chứng quyết định giao nhiệm vụ / Biên bản nghiệm thu" name="fileMinhChung" rules={[{ required: true, validator: validateMinhChung }]}>
                    <UploadMultiFile />
                </Form.Item>
            </Form>
        </Modal>
    );
};

// 6. MODAL SÁNG CHẾ / GIẢI PHÁP HỮU ÍCH
export const SangCheModal = ({ visible, onCancel, onSubmit, initialValues }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            form.resetFields();
            form.setFieldsValue({
                ...initialValues,
                ngayThangNamCap: initialValues.ngayThangNamCap ? dayjs(initialValues.ngayThangNamCap) : null
            });
        }
    }, [visible, initialValues, form]);

    const handleOk = () => {
        form.validateFields().then(values => {
            onSubmit({
                ...values,
                ngayThangNamCap: values.ngayThangNamCap ? dayjs(values.ngayThangNamCap).format('YYYY-MM-DD') : null
            });
        }).catch(() => {});
    };

    return (
        <Modal
            title={initialValues.id ? "Sửa bằng sáng chế / GPHU" : "Khai báo Bằng sáng chế / GPHU"}
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            okText="Lưu lại (Chờ duyệt)"
            cancelText="Hủy bỏ"
        >
            <Form form={form} layout="vertical">
                <Form.Item name="tenBangSangChe" label="Tên bằng sáng chế / GPHU " rules={[{ required: true, message: 'Nhập tên bằng sáng chế/GPHU' }]}>
                    <TextArea rows={2} placeholder="Tên sáng chế hoặc giải pháp hữu ích được công nhận" />
                </Form.Item>

                <Form.Item name="tenCoQuanCap" label="Cơ quan cấp bằng độc quyền " rules={[{ required: true, message: 'Nhập tên cơ quan cấp' }]}>
                    <Input placeholder="Ví dụ: Cục Sở hữu trí tuệ Việt Nam..." />
                </Form.Item>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="ngayThangNamCap" label="Ngày tháng năm cấp " rules={[{ required: true, message: 'Chọn ngày cấp' }]}>
                            <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="vaiTroTacGia" label="Vai trò sáng chế " rules={[{ required: true, message: 'Chọn vai trò' }]}>
                            <Select placeholder="Chọn vai trò của bạn">
                                {VAI_TRO_SANG_CHE.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="soTacGia" label="Số lượng tác giả " rules={[{ required: true, message: 'Nhập số tác giả' }]}>
                            <InputNumber min={1} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item label="Minh chứng (Ảnh bằng độc quyền / Quyết định)" name="fileMinhChung" rules={[{ required: true, validator: validateMinhChung }]}>
                    <UploadMultiFile />
                </Form.Item>
            </Form>
        </Modal>
    );
};

// 7. MODAL GIẢI THƯỞNG KHOA HỌC (NCKH)
export const GiaiThuongModal = ({ visible, onCancel, onSubmit, initialValues }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            form.resetFields();
            form.setFieldsValue(initialValues);
        }
    }, [visible, initialValues, form]);

    const handleOk = () => {
        form.validateFields().then(values => {
            onSubmit(values);
        }).catch(() => {});
    };

    return (
        <Modal
            title={initialValues.id ? "Sửa giải thưởng NCKH" : "Khai báo Giải thưởng NCKH mới"}
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            okText="Lưu lại (Chờ duyệt)"
            cancelText="Hủy bỏ"
        >
            <Form form={form} layout="vertical">
                <Form.Item name="hinhThucVaNoiDung" label="Hình thức và nội dung giải thưởng " rules={[{ required: true, message: 'Nhập nội dung giải thưởng' }]}>
                    <TextArea rows={2} placeholder="Nội dung giải thưởng khoa học công nghệ nhận được" />
                </Form.Item>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="namTangThuong" label="Năm tặng thưởng " rules={[{ required: true, message: 'Nhập năm nhận' }]}>
                            <InputNumber style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="capCongNhan" label="Cấp công nhận giải thưởng " rules={[{ required: true, message: 'Chọn cấp giải thưởng' }]}>
                            <Select placeholder="Chọn cấp giải thưởng">
                                {CAP_GIAI_THUONG.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item label="Minh chứng (Giấy khen / Bằng khen / Cúp...)" name="fileMinhChung" rules={[{ required: true, validator: validateMinhChung }]}>
                    <UploadMultiFile />
                </Form.Item>
            </Form>
        </Modal>
    );
};

// 8. MODAL SÁCH CHUYÊN KHẢO / GIÁO TRÌNH
export const SachModal = ({ visible, onCancel, onSubmit, initialValues }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            form.resetFields();
            form.setFieldsValue(initialValues);
        }
    }, [visible, initialValues, form]);

    const handleOk = () => {
        form.validateFields().then(values => {
            onSubmit(values);
        }).catch(() => {});
    };

    return (
        <Modal
            title={initialValues.id ? "Sửa sách xuất bản" : "Khai báo Sách chuyên khảo, giáo trình"}
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            width={700}
            okText="Lưu lại (Chờ duyệt)"
            cancelText="Hủy bỏ"
        >
            <Form form={form} layout="vertical">
                <Form.Item name="tenSach" label="Tên sách " rules={[{ required: true, message: 'Nhập tên sách' }]}>
                    <Input placeholder="Tên đầy đủ của sách chuyên khảo, giáo trình" />
                </Form.Item>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="loaiSach" label="Thể loại sách " rules={[{ required: true, message: 'Chọn loại sách' }]}>
                            <Select placeholder="Chọn thể loại sách">
                                {LOAI_SACH.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="nhaXuatBan" label="Nhà xuất bản " rules={[{ required: true, message: 'Nhập nhà xuất bản' }]}>
                            <Input placeholder="Tên nhà xuất bản" />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} sm={8} md={8}>
                        <Form.Item name="namXuatBan" label="Năm xuất bản " rules={[{ required: true, message: 'Nhập năm' }]}>
                            <InputNumber style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={8} md={8}>
                        <Form.Item name="soTacGia" label="Số lượng đồng tác giả " rules={[{ required: true, message: 'Nhập số tác giả' }]}>
                            <InputNumber min={1} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={8} md={8}>
                        <Form.Item name="vaiTro" label="Vai trò của bạn " rules={[{ required: true, message: 'Chọn vai trò' }]}>
                            <Select placeholder="Chọn vai trò">
                                {VAI_TRO_SACH.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="phanBienSoanTuTrang" label="Biên soạn từ trang " rules={[{ required: true, message: 'Trang bắt đầu' }]}>
                            <InputNumber min={1} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="phanBienSoanDenTrang" label="Biên soạn đến trang " rules={[{ required: true, message: 'Trang kết thúc' }]}>
                            <InputNumber min={1} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item name="soChuongSach" label="Số chương sách biên soạn " rules={[{ required: true, message: 'Vui lòng nhập số chương sách biên soạn' }]}>
                    <Input placeholder="Ví dụ: 3 chương, Chương 1 và 2..." />
                </Form.Item>

                <Form.Item name="xacNhanCoSo" label="Thông tin xác nhận của cơ sở đào tạo">
                    <Input placeholder="Ví dụ: Quyết định phê duyệt số... của Hội đồng khoa học..." />
                </Form.Item>

                <Form.Item label="Minh chứng (Ảnh bìa sách / Trang xi-nhê chứa tên)" name="fileMinhChung" rules={[{ required: true, validator: validateMinhChung }]}>
                    <UploadMultiFile />
                </Form.Item>
            </Form>
        </Modal>
    );
};

// 9. MODAL HƯỚNG DẪN HỌC VIÊN
export const HuongDanModal = ({ visible, onCancel, onSubmit, initialValues }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            form.resetFields();
            form.setFieldsValue({
                ...initialValues,
                thoiGianHuongDanTu: initialValues.thoiGianHuongDanTu ? dayjs(initialValues.thoiGianHuongDanTu) : null,
                thoiGianHuongDanDen: initialValues.thoiGianHuongDanDen ? dayjs(initialValues.thoiGianHuongDanDen) : null,
                thoiGianDaoTaoTu: initialValues.thoiGianDaoTaoTu ? dayjs(initialValues.thoiGianDaoTaoTu) : null,
                thoiGianDaoTaoDen: initialValues.thoiGianDaoTaoDen ? dayjs(initialValues.thoiGianDaoTaoDen) : null,
            });
        }
    }, [visible, initialValues, form]);

    const handleOk = () => {
        form.validateFields().then(values => {
            onSubmit({
                ...values,
                thoiGianHuongDanTu: values.thoiGianHuongDanTu ? dayjs(values.thoiGianHuongDanTu).format('YYYY-MM-DD') : null,
                thoiGianHuongDanDen: values.thoiGianHuongDanDen ? dayjs(values.thoiGianHuongDanDen).format('YYYY-MM-DD') : null,
                thoiGianDaoTaoTu: values.thoiGianDaoTaoTu ? dayjs(values.thoiGianDaoTaoTu).format('YYYY-MM-DD') : null,
                thoiGianDaoTaoDen: values.thoiGianDaoTaoDen ? dayjs(values.thoiGianDaoTaoDen).format('YYYY-MM-DD') : null,
            });
        }).catch(() => {});
    };

    return (
        <Modal
            title={initialValues.id ? "Sửa hướng dẫn học viên" : "Khai báo Hướng dẫn học viên mới"}
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            width={700}
            okText="Lưu lại (Chờ duyệt)"
            cancelText="Hủy bỏ"
        >
            <Form form={form} layout="vertical">
                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="hoTenHocVien" label="Họ tên học viên " rules={[{ required: true, message: 'Nhập họ tên học viên' }]}>
                            <Input placeholder="Họ và tên học viên được hướng dẫn" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="doiTuong" label="Bậc đào tạo học viên " rules={[{ required: true, message: 'Chọn bậc học viên' }]}>
                            <Select placeholder="Chọn loại học viên">
                                {BAC_HOC_VIEN.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item name="tenDeTai" label="Tên đề tài của học viên " rules={[{ required: true, message: 'Nhập tên đề tài luận văn/luận án' }]}>
                    <TextArea rows={2} placeholder="Tên đề tài khóa học luận án / luận văn tốt nghiệp" />
                </Form.Item>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="trachNhiemHuongDan" label="Trách nhiệm hướng dẫn " rules={[{ required: true, message: 'Chọn trách nhiệm hướng dẫn' }]}>
                            <Select placeholder="Chọn vai trò">
                                {TRACH_NHIEM_HD.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="coSoDaoTao" label="Cơ sở đào tạo " rules={[{ required: true, message: 'Nhập cơ sở đào tạo' }]}>
                            <Input placeholder="Trường đại học / Học viện / Bệnh viện..." />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} sm={8} md={8}>
                        <Form.Item name="thoiGianHuongDanTu" label="Thời gian từ ngày" rules={[{ required: true, message: 'Bắt đầu hướng dẫn' }]}>
                            <DatePicker picker="month" format="MM/YYYY" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={8} md={8}>
                        <Form.Item name="thoiGianHuongDanDen" label="Thời gian đến ngày" rules={[{ required: true, message: 'Kết thúc hướng dẫn' }]}>
                            <DatePicker picker="month" format="MM/YYYY" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col xs={24} md={16}>
                        <Form.Item name="thoiDiemBaoVe" label="Thời điểm bảo vệ (ghi rõ dd/mm/yyyy nếu đã BV)" rules={[{ required: true, message: 'Nhập thời điểm bảo vệ' }]}>
                            <Input placeholder="Ví dụ: 26/06/2026..." />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="thoiGianDaoTaoTu" label="Thời gian đào tạo của học viên theo QĐ: Từ ngày" rules={[{ required: true, message: 'Chọn thời gian đào tạo từ ngày' }]}>
                            <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="thoiGianDaoTaoDen" label="Thời gian đào tạo của học viên theo QĐ: Đến ngày" rules={[{ required: true, message: 'Chọn thời gian đào tạo đến ngày' }]}>
                            <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item name="trangThai" label="Trạng thái hướng dẫn " rules={[{ required: true, message: 'Chọn trạng thái' }]}>
                    <Radio.Group>
                        {TRANG_THAI_HD.map(o => <Radio key={o.value} value={o.value}>{o.label}</Radio>)}
                    </Radio.Group>
                </Form.Item>

                <Form.Item label="Minh chứng quyết định giao hướng dẫn" name="fileMinhChung" rules={[{ required: true, validator: validateMinhChung }]}>
                    <UploadMultiFile />
                </Form.Item>
            </Form>
        </Modal>
    );
};

// 10. MODAL GIẢI THƯỞNG ĐÀO TẠO
export const GiaiThuongDaoTaoModal = ({ visible, onCancel, onSubmit, initialValues }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            form.resetFields();
            form.setFieldsValue(initialValues);
        }
    }, [visible, initialValues, form]);

    const handleOk = () => {
        form.validateFields().then(values => {
            onSubmit(values);
        }).catch(() => {});
    };

    return (
        <Modal
            title={initialValues.id ? "Sửa giải thưởng giảng dạy" : "Khai báo Giải thưởng Đào tạo / Giảng dạy mới"}
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            okText="Lưu lại (Chờ duyệt)"
            cancelText="Hủy bỏ"
        >
            <Form form={form} layout="vertical">
                <Form.Item name="tenGiaiThuong" label="Tên giải thưởng về đào tạo / giảng dạy" rules={[{ required: true, message: 'Nhập tên giải thưởng' }]}>
                    <TextArea rows={2} placeholder="Nội dung/Tên giải thưởng nhà giáo uy tín, bài giảng hay, v.v." />
                </Form.Item>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item name="namTangThuong" label="Năm tặng thưởng" rules={[{ required: true, message: 'Nhập năm nhận' }]}>
                            <InputNumber style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="capCongNhan" label="Cấp công nhận" rules={[{ required: true, message: 'Chọn cấp giải thưởng' }]}>
                            <Select placeholder="Chọn cấp giải thưởng">
                                {CAP_GIAI_THUONG.map(o => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item label="Minh chứng quyết định / Giấy khen" name="fileMinhChung" rules={[{ required: true, validator: validateMinhChung }]}>
                    <UploadMultiFile />
                </Form.Item>
            </Form>
        </Modal>
    );
};
